// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Geist-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Geist-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}


.wl{
  position: relative;
  width: 100%;
  padding: 56px 16px;
  overflow: hidden;
}

.wl__bg{
  position:absolute;
  inset:0;
  pointer-events:none;
  background: #FCF9F8;
/*  background:
    radial-gradient(900px 450px at 15% 20%, rgba(95,186,139,0.14), transparent 60%),
    radial-gradient(900px 450px at 85% 70%, rgba(17,24,39,0.10), transparent 60%),
    radial-gradient(circle at 1px 1px, rgba(17,24,39,0.06) 1px, transparent 0);
  background-size: auto, auto, 28px 28px;
  mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0.65), rgba(0,0,0,0));*/
}

.wl__inner{
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
}

.wl__grid{
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 24px;
  align-items: center;
}

@media (max-width: 900px){
  .wl__grid{ grid-template-columns: 1fr; }
}
/*
.wl__copy{
  padding: 8px 4px;
}
*/
.wl__eyebrow{
  display:inline-block;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: 12px;
  color: rgba(17,24,39,0.72);
  margin-bottom: 10px;
}

.wl__title{
  font-weight: 800;
  font-size: clamp(32px, 5vw, 56px);
  line-height: 1.05;
  margin: 0 0 12px;
  color: #0b1220;
}

.wl__titleAccent{
  color: #5fba8b;
}

.wl__subtitle{
  font-size: 16px;
  line-height: 1.55;
  color: rgba(17,24,39,0.72);
  max-width: 44ch;
  margin: 0 0 16px;
}

.wl__bullets{
  display:flex;
  flex-wrap:wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.wl__pill{
  border: 1px solid rgba(17,24,39,0.12);
  background: rgba(255,255,255,0.7);
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 13px;
  color: rgba(17,24,39,0.80);
  backdrop-filter: blur(6px);
}

.wl__fineprint{
  font-size: 13px;
  color: rgba(17,24,39,0.55);
  max-width: 52ch;
}
/* =========================
   Ribbon wrapper + diagonal divider
   ========================= */

.wl__joinWrap{
  /* FULL-BLEED: break out of the inner container padding */
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  display: flex;
  position: relative;
  overflow: visible;

  /* your borders */
  border-top: 2px solid rgba(0,0,0,1);
  border-bottom: 2px solid rgba(0,0,0,1);

  /* default divider color (thin line) */
  --wedgeLine: rgba(0,0,0,1);

  /* BACKGROUNDS (wrapper owns fill so it respects diagonal) */
  --leftBg: #FCF9F8;
  --rightBg: #FCF9F8;

  /* angle tuned to feel like your skewX(-14deg) divider */
  --splitAngle: 104deg;

  background: linear-gradient(
    var(--splitAngle),
    var(--leftBg) 0%,
    var(--leftBg) 50%,
    var(--rightBg) 50%,
    var(--rightBg) 100%
  );

  flex-direction: column;   /* stack top strip over main */

}

/* diagonal divider line */
.wl__joinWrap::after{
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform: translateX(-50%) skewX(-14deg);

  width: 0; /* line only */
  border-left: 2px solid var(--wedgeLine);

  pointer-events: none;
  z-index: 2;
}

/* hover logic drives BACKGROUND + divider */
.wl__joinWrap:has(.wl__ribbonBtn--left:hover){
  --leftBg: #5FBA8B;
  --rightBg: #FCF9F8;
  --wedgeLine: #5FBA8B;
}

.wl__joinWrap:has(.wl__ribbonBtn--right:hover){
  --leftBg: #FCF9F8;
  --rightBg: #5FBA8B;
  --wedgeLine: #5FBA8B;
}

/* optional: tint the shared border when either side is hovered
.wl__joinWrap:has(.wl__ribbonBtn:hover){
  border-top-color: #5FBA8B;
  border-bottom-color: #5FBA8B;
}*/

/* =========================
   Base button (shared)
   ========================= */

.wl__ribbonBtn{
  height: 100%;

  flex: 1 1 50%;
  border: 0;
  margin: 0;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  line-height: 1;

  /* IMPORTANT: wrapper owns background */
  background: transparent;

  transition:
    filter 0.12s ease,
    transform 0.12s ease,
    color 0.12s ease;

  position: relative;
  z-index: 1;
}

/* the text node we will scale (no reflow) */
.wl__ribbonLabel{
  display: inline-block;
  transform: scale(1);
  transform-origin: center;
  transition: transform 0.14s ease;
  will-change: transform;
  pointer-events: none; /* <-- huge */

}


/* =========================
   Left half
   ========================= */

.wl__ribbonBtn--left{
  font-family: Geist;
  font-size: 56px;
  font-weight: 800;
  color: #000000;
}

/* =========================
   Right half
   ========================= */

.wl__ribbonBtn--right{
  font-family: Geist;
  font-weight: 800;
  font-size: 56px;
  color: #000000;
}

/* =========================
   Hovers (text only — fill handled by wrapper)
   ========================= */

.wl__ribbonBtn--left:hover{
  color: #FFFFFF;
}

.wl__ribbonBtn--right:hover{
  color: #FFFFFF;
}

.wl__ribbonBtn:hover{ filter: brightness(1.03); }
.wl__ribbonBtn:active{ filter: brightness(0.98); transform: translateY(0.5px); }

/* instead: scale the label */
.wl__ribbonBtn--left:hover .wl__ribbonLabel,
.wl__ribbonBtn--right:hover .wl__ribbonLabel{
  transform: scale(1.14); /* ≈ 56->64 visual bump */
}


/* ticker effect */
/* top strip */
.wl__ribbonTop{
  height: 44px; /* thin editorial band */
  border-bottom: 2px solid rgba(0,0,0,1);
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* marquee container */
.wl__marquee{
  width: 100%;
  overflow: hidden;
}

/* moving track */
.wl__marqueeTrack{
  display: flex;
  gap: 28px;
  white-space: nowrap;
  will-change: transform;
  /* animation: wlMarquee 18s linear infinite;*/
  padding-left: 28px; /* gives it breathing room at the left edge */
  transform: translate3d(0, 0, 0);
}

/* typography */
.wl__marqueeTrack span{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 14px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(0,0,0,0.75);
}

/* main CTA row */
.wl__ribbonMain{
  position: relative;
  width: 100%;
  min-height: 98px;  /* whatever your ribbon height should be */

  height: 98px;      /* hard lock */
  overflow: hidden;  /* ensure scaled text can't "poke out" vertically */


  display: flex;            /* <-- important */
  flex-direction: row;      /* <-- important */
}

/* make existing buttons fill the main row */
.wl__ribbonMain .wl__ribbonBtn{
  min-height: 98px;
}

/* IMPORTANT:
   Move the diagonal divider line from the wrapper to the main row,
   so it DOESN’T run through the marquee strip.
*/
.wl__joinWrap::after{ content: none; }
.wl__ribbonMain::after{
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform: translateX(-50%) skewX(-14deg);
  width: 0;
  border-left: 2px solid var(--wedgeLine);
  pointer-events: none;
  z-index: 2;
}

/* also move the diagonal background split to the main row,
   so the marquee strip can stay clean */
.wl__joinWrap{
  background: none; /* wrapper no longer owns the gradient */
}
.wl__ribbonMain{
  --splitAngle: 104deg; /* keep your tuned angle */
  background: linear-gradient(
    var(--splitAngle),
    var(--leftBg) 0%,
    var(--leftBg) 50%,
    var(--rightBg) 50%,
    var(--rightBg) 100%
  );
}

/* hover logic stays the same, but now targets wrapper with :has */
.wl__joinWrap:has(.wl__ribbonBtn--left:hover){
  --leftBg: #5FBA8B;
  --rightBg: #FCF9F8;
  --wedgeLine: #5FBA8B;
}
.wl__joinWrap:has(.wl__ribbonBtn--right:hover){
  --leftBg: #FCF9F8;
  --rightBg: #5FBA8B;
  --wedgeLine: #5FBA8B;
}

/* optional: tint marquee text a bit on hover for cohesiveness */
.wl__joinWrap:has(.wl__ribbonBtn:hover) .wl__marqueeTrack span{
  color: rgba(0,0,0,0.9);
}

@keyframes wlMarquee{
  from { transform: translateX(0); }
  to   { transform: translateX(-33.333%); } /* because we repeated content */
}

/* accessibility: stop motion for users who prefer reduced motion */
@media (prefers-reduced-motion: reduce){
  .wl__marqueeTrack{ animation: none; }
}

/* =========================
   NEW: Modal overlay + container
   ========================= */

.wl__modalOverlay{
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(11,18,32,0.55);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
}

.wl__modal{
  position: relative;
  width: min(640px, 100%);
}

/* close button (optional but useful) */
.wl__modalClose{
  position: absolute;
  top: 10px;
  right: 10px;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(17,24,39,0.14);
  background: rgba(255,255,255,0.92);
  cursor: pointer;
  font-weight: 900;
  line-height: 1;
  display: grid;
  place-items: center;
  z-index: 100000; /* above panel */
}

.wl__modalClose:hover{
  filter: brightness(0.98);
}

/* IMPORTANT: panel inside modal should keep its look */
.wl__modal .wl__panel{
  width: 100%;
}

/* Mobile: slide-up-ish behavior + scroll inside if content is tall */
@media (max-width: 768px){
  .wl__modalOverlay{
    align-items: flex-end;
    padding: 14px;
  }

  .wl__modal{
    width: 100%;
  }

  .wl__modal .wl__panel{
    max-height: 85vh;
    overflow: auto; /* allow panel content scroll if needed */
    -webkit-overflow-scrolling: touch;
  }
}

/* ========================= */

.wl__panel{
  border: 1px solid rgba(17,24,39,0.10);
  border-radius: 22px;
  background: rgba(255,255,255,0.78);
  backdrop-filter: blur(10px);
  box-shadow:
    0 12px 35px rgba(17,24,39,0.10),
    0 2px 8px rgba(17,24,39,0.06);

  overflow: visible;     /* <-- allow dropdown to escape */
  position: relative;    /* helps z-index children behave */
  z-index: 1;
}

.wl__panelTop{
  padding: 18px 18px 8px;
  border-bottom: 1px solid rgba(17,24,39,0.08);
}

.wl__panelTitle{
  font-weight: 800;
  font-size: 16px;
  color: #0b1220;
}

.wl__ref{
  margin-top: 6px;
  font-size: 13px;
  color: rgba(17,24,39,0.70);
}

.wl__refMuted{
  color: rgba(17,24,39,0.55);
}

.wl__refCode{
  font-weight: 800;
  letter-spacing: 0.06em;
}

.wl__form{
  padding: 14px 18px 18px;
}

.wl__seg{
  display:flex;
  gap: 6px;
  padding: 6px;
  border-radius: 999px;
  background: #0b1220;
  margin-bottom: 14px;
}

.wl__segBtn{
  flex:1 1;
  border: 0;
  border-radius: 999px;
  padding: 10px 10px;
  cursor: pointer;
  background: transparent;
  color: rgba(255,255,255,0.80);
  font-size: 14px;
  font-weight: 600;
}

.wl__segBtn.isActive{
  background: #ffffff;
  color: #0b1220;
}

.wl__fields{
  display:flex;
  flex-direction: column;
  gap: 12px;
}

.wl__field{
  display:flex;
  flex-direction: column;
  gap: 6px;
}

.wl__label{
  font-size: 13px;
  color: rgba(17,24,39,0.65);
  font-weight: 700;
}

.wl__input{
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(17,24,39,0.16);
  font-size: 15px;
  outline: none;
  background: rgba(255,255,255,0.92);
  border-radius: 999px;  /* pill email */
}

.wl__input:focus{
  border-color: rgba(95,186,139,0.75);
  box-shadow: 0 0 0 4px rgba(95,186,139,0.16);
}

/* =========================
   PhoneInput (FIXED v2)
   Dropdown must escape the pill (no overflow clipping)
   ========================= */

.wl__phoneWrap{
  width: 100%;
}

/* Outer pill shell */
.wl__phoneShell{
  width: 100%;
  border: 1px solid rgba(17,24,39,0.16);
  border-radius: 999px;
  background: rgba(255,255,255,0.92);
  overflow: visible;             /* <-- KEY CHANGE: allow dropdown to escape */
  position: relative;            /* anchor z-index behavior */
}

/* library wrapper */
.wl__phoneShell .react-tel-input{
  width: 100%;
  position: relative;
}

/* input: no border, transparent bg, rounded on right side */
.wl__phoneShell .wl__phoneInput{
  width: 100% !important;
  border: none !important;
  height: 46px !important;
  font-size: 15px !important;
  background: transparent !important;
  padding-left: 58px !important; /* room for flag */
  box-shadow: none !important;
  outline: none !important;
  border-radius: 0 999px 999px 0 !important;  /* right pill */
}

/* flag button area: no border, rounded on left side */
.wl__phoneShell .wl__phoneButton{
  border: none !important;
  background: transparent !important;
  border-radius: 999px 0 0 999px !important;  /* left pill */
}

/* neutralize extra borders from the theme */
.wl__phoneShell .flag-dropdown{
  border: none !important;
  background: transparent !important;
  border-radius: 999px 0 0 999px !important;
}

.wl__phoneShell .selected-flag{
  padding-left: 12px !important;
  border-radius: 999px 0 0 999px !important;
}

/* Focus ring on the shell */
.wl__phoneShell:focus-within{
  border-color: rgba(95,186,139,0.75);
  box-shadow: 0 0 0 4px rgba(95,186,139,0.16);
}

/* Dropdown: force it to render ABOVE everything, below the input */
.wl__phoneShell .country-list,
.wl__phoneDropdown{
  z-index: 99999 !important;
}

/* optional: add a little separation so it doesn't feel "inside" */
.wl__phoneShell .country-list{
  margin-top: 8px !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 30px rgba(17,24,39,0.14) !important;
  border: 1px solid rgba(17,24,39,0.12) !important;
}

/* ========================= */

.wl__cta{
  margin-top: 14px;
  width: 100%;
  border-radius: 999px;

  border: 1px solid rgba(95,186,139,0.95);
  background: #ffffff;     /* default white */
  color: #5fba8b;          /* default green text */

  font-weight: 800;
  font-size: 15px;
  padding: 12px 14px;

  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, transform 0.06s ease;
}

.wl__cta:hover{
  background: #5fba8b;     /* hover green */
  color: #ffffff;          /* hover white text */
  transform: translateY(-1px);
}

.wl__cta:disabled{
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.wl__cta:disabled:hover{
  background: #ffffff;
  color: #5fba8b;
}

.wl__status{
  margin-top: 10px;
  font-size: 13px;
  color: rgba(17,24,39,0.72);
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(17,24,39,0.04);
  border: 1px solid rgba(17,24,39,0.08);
}

.wl__share{
  margin-top: 14px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(95,186,139,0.32);
  background: rgba(95,186,139,0.08);
}

.wl__shareTitle{
  font-weight: 900;
  color: #0b1220;
  font-size: 15px;
}

.wl__shareSub{
  margin-top: 2px;
  font-size: 13px;
  color: rgba(17,24,39,0.68);
}

.wl__shareRow{
  margin-top: 10px;
  display:flex;
  gap: 8px;
  align-items: center;
}

.wl__shareRow.isMobile{
  flex-direction: column;
  align-items: stretch;
}

.wl__shareInput{
  flex:1 1;
  padding: 11px 12px;
  border-radius: 14px;
  border: 1px solid rgba(17,24,39,0.14);
  background: rgba(255,255,255,0.92);
  font-size: 14px;
}

.wl__copyBtn{
  padding: 11px 14px;
  border-radius: 14px;
  border: 1px solid rgba(17,24,39,0.14);
  background: white;
  cursor: pointer;
  font-weight: 800;
}

.wl__copyBtn:hover{
  filter: brightness(0.98);
}

.wl__shareFoot{
  margin-top: 10px;
  font-size: 13px;
  color: rgba(17,24,39,0.70);
}

.wl__privacy{
  padding: 0 18px 16px;
  font-size: 12.5px;
  color: rgba(17,24,39,0.55);
}
`, "",{"version":3,"sources":["webpack://./src/components/waitlist.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB;mEACgE;IAChE,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,mBAAmB;EACnB,mBAAmB;AACrB;;;;;0FAK0F;AAC1F;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW,0BAA0B,EAAE;AACzC;AACA;;;;CAIC;AACD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA;;8BAE8B;;AAE9B;EACE,yDAAyD;EACzD,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;;EAE9B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;;EAEjB,iBAAiB;EACjB,mCAAmC;EACnC,sCAAsC;;EAEtC,sCAAsC;EACtC,0BAA0B;;EAE1B,4DAA4D;EAC5D,iBAAiB;EACjB,kBAAkB;;EAElB,wDAAwD;EACxD,oBAAoB;;EAEpB;;;;;;GAMC;;EAED,sBAAsB,IAAI,8BAA8B;;AAE1D;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,yCAAyC;;EAEzC,QAAQ,EAAE,cAAc;EACxB,uCAAuC;;EAEvC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;EAIE;;AAEF;;8BAE8B;;AAE9B;EACE,YAAY;;EAEZ,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,cAAc;;EAEd,uCAAuC;EACvC,uBAAuB;;EAEvB;;;oBAGkB;;EAElB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB,EAAE,aAAa;;AAErC;;;AAGA;;8BAE8B;;AAE9B;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;8BAE8B;;AAE9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;8BAE8B;;AAE9B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB,wBAAwB,EAAE;AAChD,uBAAuB,wBAAwB,EAAE,4BAA4B,EAAE;;AAE/E,6BAA6B;AAC7B;;EAEE,sBAAsB,EAAE,yBAAyB;AACnD;;;AAGA,kBAAkB;AAClB,cAAc;AACd;EACE,YAAY,EAAE,wBAAwB;EACtC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB,EAAE,6CAA6C;EACjE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,+GAA+G;EAC/G,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,GAAG,0CAA0C;;EAE7D,YAAY,OAAO,cAAc;EACjC,gBAAgB,GAAG,mDAAmD;;;EAGtE,aAAa,aAAa,kBAAkB;EAC5C,mBAAmB,OAAO,kBAAkB;AAC9C;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;AACD,sBAAsB,aAAa,EAAE;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,yCAAyC;EACzC,QAAQ;EACR,uCAAuC;EACvC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;wCACwC;AACxC;EACE,gBAAgB,EAAE,wCAAwC;AAC5D;AACA;EACE,oBAAoB,EAAE,0BAA0B;EAChD;;;;;;GAMC;AACH;;AAEA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,+BAA+B,EAAE,EAAE,gCAAgC;AAC5E;;AAEA,mEAAmE;AACnE;EACE,mBAAmB,eAAe,EAAE;AACtC;;AAEA;;8BAE8B;;AAE9B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,gBAAgB;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,WAAW;AACb;;AAEA,qEAAqE;AACrE;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc,EAAE,yCAAyC;IACzD,iCAAiC;EACnC;AACF;;AAEA,8BAA8B;;AAE9B;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B;;iCAE+B;;EAE/B,iBAAiB,MAAM,iCAAiC;EACxD,kBAAkB,KAAK,kCAAkC;EACzD,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,QAAM;EACN,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,oBAAoB,GAAG,eAAe;AACxC;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;;8BAG8B;;AAE9B;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB,cAAc,6CAA6C;EAC5E,kBAAkB,aAAa,4BAA4B;AAC7D;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B,EAAE,kBAAkB;EACjD,2BAA2B;EAC3B,wBAAwB;EACxB,yCAAyC,GAAG,eAAe;AAC7D;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC,GAAG,cAAc;AAC5D;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,mEAAmE;AACnE;;EAEE,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,sDAAsD;EACtD,gDAAgD;AAClD;;AAEA,8BAA8B;;AAE9B;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;;EAEpB,uCAAuC;EACvC,mBAAmB,MAAM,kBAAkB;EAC3C,cAAc,WAAW,uBAAuB;;EAEhD,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;EAElB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB,MAAM,gBAAgB;EACzC,cAAc,WAAW,qBAAqB;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,QAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":["@font-face {\n    font-family: 'Geist';\n    src: url('../assets/fonts/Geist-Regular.woff2') format('woff2'),\n         url('../assets/fonts/Geist-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n.wl{\n  position: relative;\n  width: 100%;\n  padding: 56px 16px;\n  overflow: hidden;\n}\n\n.wl__bg{\n  position:absolute;\n  inset:0;\n  pointer-events:none;\n  background: #FCF9F8;\n/*  background:\n    radial-gradient(900px 450px at 15% 20%, rgba(95,186,139,0.14), transparent 60%),\n    radial-gradient(900px 450px at 85% 70%, rgba(17,24,39,0.10), transparent 60%),\n    radial-gradient(circle at 1px 1px, rgba(17,24,39,0.06) 1px, transparent 0);\n  background-size: auto, auto, 28px 28px;\n  mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0.65), rgba(0,0,0,0));*/\n}\n\n.wl__inner{\n  position: relative;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.wl__grid{\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: 24px;\n  align-items: center;\n}\n\n@media (max-width: 900px){\n  .wl__grid{ grid-template-columns: 1fr; }\n}\n/*\n.wl__copy{\n  padding: 8px 4px;\n}\n*/\n.wl__eyebrow{\n  display:inline-block;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: rgba(17,24,39,0.72);\n  margin-bottom: 10px;\n}\n\n.wl__title{\n  font-weight: 800;\n  font-size: clamp(32px, 5vw, 56px);\n  line-height: 1.05;\n  margin: 0 0 12px;\n  color: #0b1220;\n}\n\n.wl__titleAccent{\n  color: #5fba8b;\n}\n\n.wl__subtitle{\n  font-size: 16px;\n  line-height: 1.55;\n  color: rgba(17,24,39,0.72);\n  max-width: 44ch;\n  margin: 0 0 16px;\n}\n\n.wl__bullets{\n  display:flex;\n  flex-wrap:wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.wl__pill{\n  border: 1px solid rgba(17,24,39,0.12);\n  background: rgba(255,255,255,0.7);\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  color: rgba(17,24,39,0.80);\n  backdrop-filter: blur(6px);\n}\n\n.wl__fineprint{\n  font-size: 13px;\n  color: rgba(17,24,39,0.55);\n  max-width: 52ch;\n}\n/* =========================\n   Ribbon wrapper + diagonal divider\n   ========================= */\n\n.wl__joinWrap{\n  /* FULL-BLEED: break out of the inner container padding */\n  width: 100vw;\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n\n  display: flex;\n  position: relative;\n  overflow: visible;\n\n  /* your borders */\n  border-top: 2px solid rgba(0,0,0,1);\n  border-bottom: 2px solid rgba(0,0,0,1);\n\n  /* default divider color (thin line) */\n  --wedgeLine: rgba(0,0,0,1);\n\n  /* BACKGROUNDS (wrapper owns fill so it respects diagonal) */\n  --leftBg: #FCF9F8;\n  --rightBg: #FCF9F8;\n\n  /* angle tuned to feel like your skewX(-14deg) divider */\n  --splitAngle: 104deg;\n\n  background: linear-gradient(\n    var(--splitAngle),\n    var(--leftBg) 0%,\n    var(--leftBg) 50%,\n    var(--rightBg) 50%,\n    var(--rightBg) 100%\n  );\n\n  flex-direction: column;   /* stack top strip over main */\n\n}\n\n/* diagonal divider line */\n.wl__joinWrap::after{\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  height: 100%;\n  transform: translateX(-50%) skewX(-14deg);\n\n  width: 0; /* line only */\n  border-left: 2px solid var(--wedgeLine);\n\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* hover logic drives BACKGROUND + divider */\n.wl__joinWrap:has(.wl__ribbonBtn--left:hover){\n  --leftBg: #5FBA8B;\n  --rightBg: #FCF9F8;\n  --wedgeLine: #5FBA8B;\n}\n\n.wl__joinWrap:has(.wl__ribbonBtn--right:hover){\n  --leftBg: #FCF9F8;\n  --rightBg: #5FBA8B;\n  --wedgeLine: #5FBA8B;\n}\n\n/* optional: tint the shared border when either side is hovered\n.wl__joinWrap:has(.wl__ribbonBtn:hover){\n  border-top-color: #5FBA8B;\n  border-bottom-color: #5FBA8B;\n}*/\n\n/* =========================\n   Base button (shared)\n   ========================= */\n\n.wl__ribbonBtn{\n  height: 100%;\n\n  flex: 1 1 50%;\n  border: 0;\n  margin: 0;\n  padding: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  line-height: 1;\n\n  /* IMPORTANT: wrapper owns background */\n  background: transparent;\n\n  transition:\n    filter 0.12s ease,\n    transform 0.12s ease,\n    color 0.12s ease;\n\n  position: relative;\n  z-index: 1;\n}\n\n/* the text node we will scale (no reflow) */\n.wl__ribbonLabel{\n  display: inline-block;\n  transform: scale(1);\n  transform-origin: center;\n  transition: transform 0.14s ease;\n  will-change: transform;\n  pointer-events: none; /* <-- huge */\n\n}\n\n\n/* =========================\n   Left half\n   ========================= */\n\n.wl__ribbonBtn--left{\n  font-family: Geist;\n  font-size: 56px;\n  font-weight: 800;\n  color: #000000;\n}\n\n/* =========================\n   Right half\n   ========================= */\n\n.wl__ribbonBtn--right{\n  font-family: Geist;\n  font-weight: 800;\n  font-size: 56px;\n  color: #000000;\n}\n\n/* =========================\n   Hovers (text only — fill handled by wrapper)\n   ========================= */\n\n.wl__ribbonBtn--left:hover{\n  color: #FFFFFF;\n}\n\n.wl__ribbonBtn--right:hover{\n  color: #FFFFFF;\n}\n\n.wl__ribbonBtn:hover{ filter: brightness(1.03); }\n.wl__ribbonBtn:active{ filter: brightness(0.98); transform: translateY(0.5px); }\n\n/* instead: scale the label */\n.wl__ribbonBtn--left:hover .wl__ribbonLabel,\n.wl__ribbonBtn--right:hover .wl__ribbonLabel{\n  transform: scale(1.14); /* ≈ 56->64 visual bump */\n}\n\n\n/* ticker effect */\n/* top strip */\n.wl__ribbonTop{\n  height: 44px; /* thin editorial band */\n  border-bottom: 2px solid rgba(0,0,0,1);\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n/* marquee container */\n.wl__marquee{\n  width: 100%;\n  overflow: hidden;\n}\n\n/* moving track */\n.wl__marqueeTrack{\n  display: flex;\n  gap: 28px;\n  white-space: nowrap;\n  will-change: transform;\n  /* animation: wlMarquee 18s linear infinite;*/\n  padding-left: 28px; /* gives it breathing room at the left edge */\n  transform: translate3d(0, 0, 0);\n}\n\n/* typography */\n.wl__marqueeTrack span{\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(0,0,0,0.75);\n}\n\n/* main CTA row */\n.wl__ribbonMain{\n  position: relative;\n  width: 100%;\n  min-height: 98px;  /* whatever your ribbon height should be */\n\n  height: 98px;      /* hard lock */\n  overflow: hidden;  /* ensure scaled text can't \"poke out\" vertically */\n\n\n  display: flex;            /* <-- important */\n  flex-direction: row;      /* <-- important */\n}\n\n/* make existing buttons fill the main row */\n.wl__ribbonMain .wl__ribbonBtn{\n  min-height: 98px;\n}\n\n/* IMPORTANT:\n   Move the diagonal divider line from the wrapper to the main row,\n   so it DOESN’T run through the marquee strip.\n*/\n.wl__joinWrap::after{ content: none; }\n.wl__ribbonMain::after{\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  height: 100%;\n  transform: translateX(-50%) skewX(-14deg);\n  width: 0;\n  border-left: 2px solid var(--wedgeLine);\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* also move the diagonal background split to the main row,\n   so the marquee strip can stay clean */\n.wl__joinWrap{\n  background: none; /* wrapper no longer owns the gradient */\n}\n.wl__ribbonMain{\n  --splitAngle: 104deg; /* keep your tuned angle */\n  background: linear-gradient(\n    var(--splitAngle),\n    var(--leftBg) 0%,\n    var(--leftBg) 50%,\n    var(--rightBg) 50%,\n    var(--rightBg) 100%\n  );\n}\n\n/* hover logic stays the same, but now targets wrapper with :has */\n.wl__joinWrap:has(.wl__ribbonBtn--left:hover){\n  --leftBg: #5FBA8B;\n  --rightBg: #FCF9F8;\n  --wedgeLine: #5FBA8B;\n}\n.wl__joinWrap:has(.wl__ribbonBtn--right:hover){\n  --leftBg: #FCF9F8;\n  --rightBg: #5FBA8B;\n  --wedgeLine: #5FBA8B;\n}\n\n/* optional: tint marquee text a bit on hover for cohesiveness */\n.wl__joinWrap:has(.wl__ribbonBtn:hover) .wl__marqueeTrack span{\n  color: rgba(0,0,0,0.9);\n}\n\n@keyframes wlMarquee{\n  from { transform: translateX(0); }\n  to   { transform: translateX(-33.333%); } /* because we repeated content */\n}\n\n/* accessibility: stop motion for users who prefer reduced motion */\n@media (prefers-reduced-motion: reduce){\n  .wl__marqueeTrack{ animation: none; }\n}\n\n/* =========================\n   NEW: Modal overlay + container\n   ========================= */\n\n.wl__modalOverlay{\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(11,18,32,0.55);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 22px;\n}\n\n.wl__modal{\n  position: relative;\n  width: min(640px, 100%);\n}\n\n/* close button (optional but useful) */\n.wl__modalClose{\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  border: 1px solid rgba(17,24,39,0.14);\n  background: rgba(255,255,255,0.92);\n  cursor: pointer;\n  font-weight: 900;\n  line-height: 1;\n  display: grid;\n  place-items: center;\n  z-index: 100000; /* above panel */\n}\n\n.wl__modalClose:hover{\n  filter: brightness(0.98);\n}\n\n/* IMPORTANT: panel inside modal should keep its look */\n.wl__modal .wl__panel{\n  width: 100%;\n}\n\n/* Mobile: slide-up-ish behavior + scroll inside if content is tall */\n@media (max-width: 768px){\n  .wl__modalOverlay{\n    align-items: flex-end;\n    padding: 14px;\n  }\n\n  .wl__modal{\n    width: 100%;\n  }\n\n  .wl__modal .wl__panel{\n    max-height: 85vh;\n    overflow: auto; /* allow panel content scroll if needed */\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* ========================= */\n\n.wl__panel{\n  border: 1px solid rgba(17,24,39,0.10);\n  border-radius: 22px;\n  background: rgba(255,255,255,0.78);\n  backdrop-filter: blur(10px);\n  box-shadow:\n    0 12px 35px rgba(17,24,39,0.10),\n    0 2px 8px rgba(17,24,39,0.06);\n\n  overflow: visible;     /* <-- allow dropdown to escape */\n  position: relative;    /* helps z-index children behave */\n  z-index: 1;\n}\n\n.wl__panelTop{\n  padding: 18px 18px 8px;\n  border-bottom: 1px solid rgba(17,24,39,0.08);\n}\n\n.wl__panelTitle{\n  font-weight: 800;\n  font-size: 16px;\n  color: #0b1220;\n}\n\n.wl__ref{\n  margin-top: 6px;\n  font-size: 13px;\n  color: rgba(17,24,39,0.70);\n}\n\n.wl__refMuted{\n  color: rgba(17,24,39,0.55);\n}\n\n.wl__refCode{\n  font-weight: 800;\n  letter-spacing: 0.06em;\n}\n\n.wl__form{\n  padding: 14px 18px 18px;\n}\n\n.wl__seg{\n  display:flex;\n  gap: 6px;\n  padding: 6px;\n  border-radius: 999px;\n  background: #0b1220;\n  margin-bottom: 14px;\n}\n\n.wl__segBtn{\n  flex:1;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 10px;\n  cursor: pointer;\n  background: transparent;\n  color: rgba(255,255,255,0.80);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.wl__segBtn.isActive{\n  background: #ffffff;\n  color: #0b1220;\n}\n\n.wl__fields{\n  display:flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wl__field{\n  display:flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wl__label{\n  font-size: 13px;\n  color: rgba(17,24,39,0.65);\n  font-weight: 700;\n}\n\n.wl__input{\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid rgba(17,24,39,0.16);\n  font-size: 15px;\n  outline: none;\n  background: rgba(255,255,255,0.92);\n  border-radius: 999px;  /* pill email */\n}\n\n.wl__input:focus{\n  border-color: rgba(95,186,139,0.75);\n  box-shadow: 0 0 0 4px rgba(95,186,139,0.16);\n}\n\n/* =========================\n   PhoneInput (FIXED v2)\n   Dropdown must escape the pill (no overflow clipping)\n   ========================= */\n\n.wl__phoneWrap{\n  width: 100%;\n}\n\n/* Outer pill shell */\n.wl__phoneShell{\n  width: 100%;\n  border: 1px solid rgba(17,24,39,0.16);\n  border-radius: 999px;\n  background: rgba(255,255,255,0.92);\n  overflow: visible;             /* <-- KEY CHANGE: allow dropdown to escape */\n  position: relative;            /* anchor z-index behavior */\n}\n\n/* library wrapper */\n.wl__phoneShell .react-tel-input{\n  width: 100%;\n  position: relative;\n}\n\n/* input: no border, transparent bg, rounded on right side */\n.wl__phoneShell .wl__phoneInput{\n  width: 100% !important;\n  border: none !important;\n  height: 46px !important;\n  font-size: 15px !important;\n  background: transparent !important;\n  padding-left: 58px !important; /* room for flag */\n  box-shadow: none !important;\n  outline: none !important;\n  border-radius: 0 999px 999px 0 !important;  /* right pill */\n}\n\n/* flag button area: no border, rounded on left side */\n.wl__phoneShell .wl__phoneButton{\n  border: none !important;\n  background: transparent !important;\n  border-radius: 999px 0 0 999px !important;  /* left pill */\n}\n\n/* neutralize extra borders from the theme */\n.wl__phoneShell .flag-dropdown{\n  border: none !important;\n  background: transparent !important;\n  border-radius: 999px 0 0 999px !important;\n}\n\n.wl__phoneShell .selected-flag{\n  padding-left: 12px !important;\n  border-radius: 999px 0 0 999px !important;\n}\n\n/* Focus ring on the shell */\n.wl__phoneShell:focus-within{\n  border-color: rgba(95,186,139,0.75);\n  box-shadow: 0 0 0 4px rgba(95,186,139,0.16);\n}\n\n/* Dropdown: force it to render ABOVE everything, below the input */\n.wl__phoneShell .country-list,\n.wl__phoneDropdown{\n  z-index: 99999 !important;\n}\n\n/* optional: add a little separation so it doesn't feel \"inside\" */\n.wl__phoneShell .country-list{\n  margin-top: 8px !important;\n  border-radius: 14px !important;\n  box-shadow: 0 10px 30px rgba(17,24,39,0.14) !important;\n  border: 1px solid rgba(17,24,39,0.12) !important;\n}\n\n/* ========================= */\n\n.wl__cta{\n  margin-top: 14px;\n  width: 100%;\n  border-radius: 999px;\n\n  border: 1px solid rgba(95,186,139,0.95);\n  background: #ffffff;     /* default white */\n  color: #5fba8b;          /* default green text */\n\n  font-weight: 800;\n  font-size: 15px;\n  padding: 12px 14px;\n\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, transform 0.06s ease;\n}\n\n.wl__cta:hover{\n  background: #5fba8b;     /* hover green */\n  color: #ffffff;          /* hover white text */\n  transform: translateY(-1px);\n}\n\n.wl__cta:disabled{\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.wl__cta:disabled:hover{\n  background: #ffffff;\n  color: #5fba8b;\n}\n\n.wl__status{\n  margin-top: 10px;\n  font-size: 13px;\n  color: rgba(17,24,39,0.72);\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(17,24,39,0.04);\n  border: 1px solid rgba(17,24,39,0.08);\n}\n\n.wl__share{\n  margin-top: 14px;\n  padding: 14px;\n  border-radius: 18px;\n  border: 1px solid rgba(95,186,139,0.32);\n  background: rgba(95,186,139,0.08);\n}\n\n.wl__shareTitle{\n  font-weight: 900;\n  color: #0b1220;\n  font-size: 15px;\n}\n\n.wl__shareSub{\n  margin-top: 2px;\n  font-size: 13px;\n  color: rgba(17,24,39,0.68);\n}\n\n.wl__shareRow{\n  margin-top: 10px;\n  display:flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.wl__shareRow.isMobile{\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.wl__shareInput{\n  flex:1;\n  padding: 11px 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(17,24,39,0.14);\n  background: rgba(255,255,255,0.92);\n  font-size: 14px;\n}\n\n.wl__copyBtn{\n  padding: 11px 14px;\n  border-radius: 14px;\n  border: 1px solid rgba(17,24,39,0.14);\n  background: white;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.wl__copyBtn:hover{\n  filter: brightness(0.98);\n}\n\n.wl__shareFoot{\n  margin-top: 10px;\n  font-size: 13px;\n  color: rgba(17,24,39,0.70);\n}\n\n.wl__privacy{\n  padding: 0 18px 16px;\n  font-size: 12.5px;\n  color: rgba(17,24,39,0.55);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
